<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/maintain/config/mould/page" getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item class="noborder" :label="$t('baoyangfenzu')">
						<el-input disabled v-model="$attrs.mold.group"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<!--        :ids.sync="yt.conditions.mouldId"-->
				<yi_cross_select :selectTitle="'name'" ref="material" buttonType="primary" :component="'web_base_mould_list'" multiple :isInput="true" :isButton="true" :buttonTitle="'xinzeng'" :ids.sync="mouldIds" @getItems="getItems">
				</yi_cross_select>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/maintain/config/mould/delete')">{{ $t('shanchu') }}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>
	</div>
</template>
<script type="text/javascript">
export default {
	name: 'web_mold_management_maintenance_settings_mold',
	data() {
		return {
			key: 0,
			mouldIds: [],
			moldId: '',
			columns: [{
				label: 'mojubianhao',
				prop: 'mould.no',
				width: 150
			}, {
				label: 'mujubianma',
				prop: 'mould.code',
				width: 150
			}, {
				label: 'mujumingcheng',
				prop: 'mould.name',
			}, {
				label: 'caozuo',
				type: 'slot',
				width: 180,
				fixed: 'right'
			}]
		};
	},
	created() {
		setTimeout(() => {
			this.yt.conditions = {
				maintainConfigId: this.$attrs.mold.id,
				// mouldId: this.yt.conditions.mouldId
				mouldIds: this.mouldIds
			}
			this.yt.get(1);
			// this.getOrganizationList();
		}, 300)

	},
	watch: {
		'yt.conditions.mouldId': {
			handler(n) {
				console.log('jjjjjj', n)
				if (n) {
					// this.yt.get(1);
				}
			},
			immediate: false,
			deep: true
		}
	},
	methods: {
		getItems(items) {
			console.log('this.items', items)
			if (items.length == 0) {
				return
			}

			this.http.post('/web/maintain/config/mould/batchCreate', {
				mouldIds: this.mouldIds,
				maintainConfigId: this.$attrs.mold.id,
			}).then(res => {
				this.yt.get(1);
				this.$message.success(this.$t(res.msg))
			}).catch(error => {
				this.$message.error(this.$t(error))
			}).finally(() => {

				this.$refs.material.setIds([])

			})
		},
		// 重置
		clear() {
			this.yt.conditions = {
				pageNum: 1,
				pageSize: 10
			}
			this.yt.get(1)
		},
	}
};
</script>
